exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.position-relative[data-v-9e89a95c] {\n    position: relative;\n}\n/* Overlay full covering */\n.loading-overlay[data-v-9e89a95c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.7); /* Fond semi-transparent */\n    z-index: 10;\n}\n.spinner-border[data-v-9e89a95c] {\n    width: 3rem;\n    height: 3rem;\n}\n", ""]);

// exports
